/**
 * Initialize the 'ui.featureFlags' state.
 *
 * @type {Object}
 */
const INITIAL_STATE = {
    isPackagingEnabled: false,
};

export default INITIAL_STATE;
